<template>
  <div class="link-block-base" :style="styles" v-if="!!linkItemList && linkItemList.length > 0">
    <div class="link-wrap">
      <div
        class="link-item"
        v-for="(item, idx) in linkItemList"
        :key="idx"
        :class="{
          'heading': item.type === bannerType.heading,
          'static-img': item.type === bannerType.staticImg,
        }"
        @click="onLinkItemClick(idx)"
      >
        <h3 v-if="item.type === bannerType.heading">
          <img v-if="!!item.img_url" :src="item.img_url">
          <span v-else v-html="item.extend_body"></span>
        </h3>
        <template v-else-if="item.type === bannerType.staticImg">
          <img :src="item.img_url">
        </template>
        <template v-else>
          <span class="message" v-html="item.memo"></span>
          <span class="arrow"><span></span></span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { BANNER_TYPE } from '@/utvStore/components/recommend/lp/statics'
export default {
  name: 'LinkBlock',
  props: {
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
    linkItemList: {
      type: Array,
    }
  },
  data() {
    return {
      bannerType: BANNER_TYPE,
    }
  },
  computed: {
    styles(){
      return {
        '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : '#ff7497',
        '--font-color': !!this.colorScheme.fontColor ? this.colorScheme.fontColor : '#303030',
        '--border-color': !!this.colorScheme.borderColor ? this.colorScheme.borderColor : '#303030',
      }
    },
  },
  methods: {
    onLinkItemClick(val) {
      const dt = this.linkItemList[val]
      if(dt.type === BANNER_TYPE.link) {
        if(dt.outerLink){
          window.open(dt.url, '_blank')
        }else{
          location.href = dt.url
        }
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.link-block-base{
  width: 100%;
  padding: 20px 20px;
  .link-wrap {
    width: 100%;
    background: #fff;
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 20px 20px;
    .link-item {
      font-weight: 600;
      font-size: 14px;
      color: var(--font-color);
      padding: 20px 34px 20px 0;
      border-bottom: 1px solid #dadada;
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      &.heading {
        width: 100%;
        padding: 20px 0;
        border: none;
        cursor: default;
        h3 {
          width: 100%;
          font-size: 24px;
          line-height: 1;
          text-align: center;
          margin: 0;
        }
      }
      &.static-img {
        padding: 20px 0;
        border: none;
        cursor: default;
      }
      .arrow {
        display: block;
        position: absolute;
        right: 0;
        width: 28px;
        height: 28px;
        background: var(--key-color);
        border-radius: 20px;
        span {
          display: block;
          width: 100%;
          height: 100%;
          position: relative;
          &::before,
          &::after {
            content: "";
            position: absolute;
            transform-origin: right center;
            height: 2px;
            width: 10px;
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
            background: white;
            top: 0;
            bottom: 0;
            right: 10px;
            margin: auto;
          }
          &::before {
            transform: translate(0, 0.5px) rotate(45deg);
          }
          &::after {
            transform: translate(0, -0.5px) rotate(-45deg);
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/partials/LinkBlock.vue